import { useContext, useEffect } from "react";
import PunonjesitContext from "../store/PunonjesitContext";
import EmployeeSpecsFilterBar from "./EmployeeSpecsFilterBar";

/**
 * Context-wired period filter for employee specs tabs.
 *
 * variant:
 *  - "full"  → Oraret (year + months + from/to)
 *  - "month" → Paga (year + months)
 *  - "year"  → Lejet (multi-select years with leave data)
 */
const SpecsPeriodFilter = ({ variant = "full" }) => {
  const { specsData } = useContext(PunonjesitContext);

  useEffect(() => {
    if (!specsData) return;
    if (variant === "year") {
      specsData.enterYearMode?.();
    } else if (variant === "month" || variant === "full") {
      if (specsData.mode === "year" || specsData.mode === "years") {
        specsData.enterMonthMode?.();
      }
    }
  }, [variant]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!specsData) return null;

  return (
    <EmployeeSpecsFilterBar
      variant={variant}
      year={specsData.year}
      selectedMonth={
        variant === "year" || specsData.mode === "custom"
          ? null
          : specsData.month
      }
      selectedYears={specsData.selectedYears}
      yearsWithData={specsData.yearsWithData}
      fromDate={specsData.fromDate}
      toDate={specsData.toDate}
      monthsWithData={specsData.monthsWithData}
      loading={
        specsData.loading ||
        specsData.activityLoading ||
        specsData.leaveYearsLoading
      }
      onYearChange={(y) =>
        specsData.onYearChange?.(y, { yearOnly: variant === "year" })
      }
      onMonthSelect={specsData.onMonthSelect}
      onYearToggle={specsData.onYearToggle}
      onRangeApply={specsData.onRangeApply}
    />
  );
};

export default SpecsPeriodFilter;
